import type { DrawingAOIMode } from "../types";

export function createLeafletDrawingAOI(map: any, mode: DrawingAOIMode)
{
  return {
    activate()
    {

    },

    deactivate() { },
  };
}
